import React from 'react';
import Panel from '../../components/ui/Panel';
import Icon from '../../components/ui/Icon';
import { iconNames } from '../../lib/Icon';

const IconsPage: React.FC = () => {
  return (
    <div>
      <h1 id="overview" className="text-3xl text-osrs-gold font-bold uppercase mb-4">Icons</h1>
      <p className="text-osrs-yellow mb-8">
        The package ships interface chrome drawn as original geometry. Close, arrows, check, and search. It does not include item or skill sprites, because those images are Jagex artwork.
      </p>

      <section id="interface-icons" className="mb-12">
        <h2 className="text-2xl text-osrs-gold font-bold uppercase mb-6">Interface Icons</h2>
        <Panel>
          <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
            {iconNames.map((name) => (
              <div key={name} className="flex flex-col items-center gap-2 text-osrs-yellow">
                <span className="osrs-btn">
                  <Icon name={name} />
                </span>
                <code>{name}</code>
              </div>
            ))}
          </div>
          <pre className="bg-osrs-black p-4 mt-6 text-osrs-yellow overflow-x-auto">{`import { Icon } from 'osrs-design-system';

<Icon name="close" />`}</pre>
        </Panel>
      </section>

      <section id="item-icons" className="mb-12">
        <h2 className="text-2xl text-osrs-gold font-bold uppercase mb-6">Item Icons</h2>
        <Panel>
          <p className="text-osrs-yellow">
            Pass your own image to InventorySlot. The slot will pixelate it. Do not copy item icons out of the game client into this package.
          </p>
          <pre className="bg-osrs-black p-4 mt-4 text-osrs-yellow overflow-x-auto">{`<InventorySlot item={{ name: 'Shark', image: '/items/shark.png', quantity: 12 }} />`}</pre>
        </Panel>
      </section>

      <section id="skill-icons" className="mb-12">
        <h2 className="text-2xl text-osrs-gold font-bold uppercase mb-6">Skill Icons</h2>
        <Panel>
          <p className="text-osrs-yellow">
            Skill icons are the same case as item icons. Use a name or your own image beside a ProgressBar. This package does not redistribute the skill sprites.
          </p>
        </Panel>
      </section>

      <section id="usage-guidelines" className="mb-12">
        <h2 className="text-2xl text-osrs-gold font-bold uppercase mb-6">Usage Guidelines</h2>
        <Panel>
          <ul className="list-disc list-inside text-osrs-yellow space-y-2 ml-4">
            <li>Icons inherit the current text colour.</li>
            <li>They are hidden from assistive tech. Put the name on the button.</li>
            <li>Use close on window titles, and the arrows on a scrollbar.</li>
          </ul>
        </Panel>
      </section>
    </div>
  );
};

export default IconsPage;
